import {Component, OnInit} from '@angular/core';

import {ProductsCategoryService} from './products-category.service';
import {ProductsArticleService} from './products-article.service';
import {ProductsCategory} from './products-category';
import {ProductsArticle} from './products-article';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {NgForm} from '@angular/forms';
import {AppComponent} from './app.component';
import {Router} from '@angular/router';
import {AuthentificationService} from './authentification.service';

@Component({
    selector: 'products-category',
    styleUrls: ['./styles/products-category.component.css'],
    templateUrl: './templates/products-category.component.html',
    providers: [ProductsCategoryService, ProductsArticleService, AuthentificationService]
})


export class ProductsCategoryComponent {
    name = 'Products Category';
    operation: string = 'CREATION CATEGORIE';
    bt_action: string = 'Valider';
    calling_function: string = 'InsertCategory()';
    category: ProductsCategory = {
        id_products_category: 1,
        name: '',
        new_reference: '',
        reference: '',
        reference_parent: ''
    };
    cat_list: ProductsCategory[];
    cat_list_select: ProductsCategory[];
    art_list: ProductsArticle[];

    hide_button = false;
    hide_dialog = false;
    validate_form_infos = false;
    delete_category: ProductsCategory;
    category_form: FormGroup;
    clear_control = true;
    showForm: boolean = true;

    //    categorie bis
    reference_tmp_old: any;
    reference_new: any = '';


    constructor(
        private products_category_service: ProductsCategoryService,
        private fb: FormBuilder,
        private app_component: AppComponent,
        private authentification_service: AuthentificationService,
        private router: Router
    ) {
        this.createForm();
        this.CheckUSerSession();
        this.app_component.valTest = '/products-category';
        this.app_component.GetParent();
    }

    
    ngOnInit(): void {
        this.GetCategoriesList();
    }

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    createForm() {
        this.category_form = this.fb.group({
            name_ctrl: ['', Validators.required],
            parent_ctrl: ['', Validators.required],
            prefix_ctrl: ['', Validators.required]
        });
    }

    /*removeForm() {
        this.category_form = this.fb.group({
            name_ctrl: '',
            parent_ctrl: '',
            prefix_ctrl: ''
        });
    }*/

    GetCategoriesList(): void {
        this.products_category_service.GetCategoriesListTree().then(cat_list => this.cat_list = cat_list);
        this.products_category_service.GetCategoriesList().then(cat_list => this.cat_list_select = cat_list);
        this.clear_control = true;
    }

    InsertCategory(): void {
        this.products_category_service.InsertCategory(this.category).then(cat_list => this.cat_list = cat_list);
        //  this.clear_control = false;
        //console.log( this.clear_control);

    }

    ValidateButton(): void {
        if (this.category_form.status === 'VALID') {
            this.category.reference = this.reference_new;
            switch (this.bt_action) {
                case 'Valider':
                    this.InsertCategory();
                    break;
                case 'Modifier':
                    this.ConfirmModification(this.category);
                    break;
            };
            this.Reset();
        }
    }

    ConfirmModification(category: ProductsCategory): void {
        this.products_category_service.ConfirmModification(this.category, this.reference_tmp_old).then(cat_list => this.cat_list = cat_list);
    }

    ModifyCatergory(category: ProductsCategory): void {
        console.log(category.reference);
        if (category.id_products_category != 1) {
            this.operation = 'MODIFICATION CATEGORIE';
            this.bt_action = 'Modifier';
            this.calling_function = 'ConfirmModification()';
            this.hide_button = true;
            this.reference_tmp_old = category.reference;
            this.products_category_service.GetCategoriesListModif(category.reference).then(cat_list => this.cat_list_select = cat_list);
            this.UpdateModelByCategory(category);
        }
    }

    DeleteCategory(): void {
        this.products_category_service.DeleteCategory(this.delete_category).then(cat_list => this.cat_list = cat_list);
        this.products_category_service.GetCategoriesList().then(cat_list => this.cat_list_select = cat_list);
        this.hide_dialog = false;
        this.app_component.hide_wrapper(this.hide_dialog);
        this.Reset();
    }

    DialogCancel(): void {
        this.hide_dialog = false;
        this.app_component.hide_wrapper(this.hide_dialog);
        //this.Reset();
    }

    DialogConfirm(category: ProductsCategory): void {
        if (category.id_products_category != 1) {
            this.delete_category = category;
            this.hide_dialog = true;
            this.app_component.hide_wrapper(this.hide_dialog);
        }

    }

    UpdateModelByCategory(category: ProductsCategory): void {
        this.category = category;
        var r = (category.reference).split(".");
        this.reference_new = r[r.length - 1];
    }

    Reset(): void {
        this.category_form.reset();
        this.showForm = false;
        setTimeout(() => {
            this.hide_button = false;
            this.bt_action = 'Valider';
            this.operation = 'CREATION CATEGORIE';
            this.createForm();
            this.showForm = true;
        });
        this.products_category_service.GetCategoriesList().then(cat_list => this.cat_list_select = cat_list);
        this.reference_tmp_old = '';
        this.reference_new = '';
    }

    setStyles(value: any) {
        let styles = {
            'padding-left': value + 'px',
        };
        return styles;
    }

}




// WEBPACK FOOTER //
// ./src/app/products-category.component.ts